import { defineStore } from 'pinia';

import { $axiosManager } from '@/api/$axios';

export const useReferralProgram = defineStore('referralProgram', () => {
  const checkReferralProgram = async (params) => {
    const res = await $axiosManager.get('/referral-program', { params });
    return res.data;
  };

  // SP2: redeem a code for the authenticated user. user_id comes from the JWT
  // (added by the $axiosManager interceptor), so the body is just the raw code.
  // Resolves with the response body on success; throws on non-2xx (caller reads
  // error.response.data.detail for the lifecycle rejection reason).
  const redeemReferralCode = async (code) => {
    const res = await $axiosManager.post('/referral-program/redeem', { code });
    return res.data;
  };

  return { checkReferralProgram, redeemReferralCode };
});
